import styled from 'styled-components'

import { toRem } from 'styles'

type Props = {
	isDisabled: boolean
	isFocused: boolean
	hasError: boolean
	hasIcon?: boolean
}

export const Label = styled.label<Props>`
	display: block;
	position: relative;
	cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'text')};
	font-size: ${toRem(14)};
	font-weight: normal;
	margin-bottom: 8px;
	border-radius: 8px;
	z-index: 1;
	text-align: left;
	color: #616161;
`
